// Italian -> English UI dictionary. When lang === "en", translate; otherwise return the key as-is (Italian).
export const EN = {
  // Common
  "Caricamento...": "Loading...",
  "Home": "Home",
  "Indietro": "Back",
  "Errore": "Error",
  "Termina": "Finish",
  "Prossima": "Next",
  "Avanti": "Next",
  "Continua": "Continue",
  "argomenti": "topics",
  "livelli": "levels",
  "domande": "questions",
  "tentativi": "attempts",
  "Studio": "Study",

  // TopBar
  "Traguardi": "Achievements",
  "Esci": "Log out",

  // Language toggle
  "Lingua": "Language",

  // Login
  "Il gioco per superare gli esami di Ingegneria Aerospaziale al Politecnico di Milano":
    "The game to ace your Aerospace Engineering exams at Politecnico di Milano",
  "Accedi": "Log in",
  "Registrati": "Sign up",
  "Nome": "Name",
  "Attendere...": "Please wait...",
  "Inizia a giocare": "Start playing",
  "Crea account": "Create account",
  "oppure": "or",
  "Continua con Google": "Continue with Google",
  "Prova con account demo": "Try the demo account",

  // Dashboard
  "I tuoi Esami": "Your Exams",
  "Carica gli appunti: l'AI li divide in argomenti e costruisce i livelli.":
    "Upload your notes: the AI splits them into topics and builds the levels.",
  "Crea nuovo esame": "Create new exam",
  "Nome + libro + appunti/foto → livelli e flashcard automatici":
    "Name + book + notes/photos → automatic levels and flashcards",
  "Nessun esame ancora. Creane uno dai tuoi appunti! 🎓📸":
    "No exams yet. Create one from your notes! 🎓📸",
  "Analisi appunti...": "Analyzing notes...",
  "Progressi": "Progress",
  "Piano": "Plan",
  "Ripasso": "Review",
  "Esame eliminato": "Exam deleted",

  // ExamCreate
  "Nuovo Esame": "New Exam",
  "Carica tutti gli appunti e le fonti dell'esame (anche foto scritte a mano). L'AI li divide automaticamente in argomenti e crea 50+ domande e flashcard per ognuno.":
    "Upload all your exam notes and sources (handwritten photos too). The AI automatically splits them into topics and creates 50+ questions and flashcards for each.",
  "Nome esame (es. Aerodinamica)": "Exam name (e.g. Aerodynamics)",
  "Libro / fonte (es. Anderson - Aerodynamics)": "Book / source (e.g. Anderson - Aerodynamics)",
  "Incolla qui gli appunti dell'intero esame...": "Paste the notes for the whole exam here...",
  "Carica foto appunti (anche a mano), PDF o testo": "Upload notes photos (handwritten too), PDF or text",
  "Inserisci il nome dell'esame": "Enter the exam name",
  "Aggiungi appunti o foto": "Add notes or photos",
  "Invio...": "Submitting...",
  "🚀 Crea esame con l'AI": "🚀 Create exam with AI",
  "Esame in preparazione! L'AI sta dividendo gli appunti 🚀":
    "Exam in progress! The AI is splitting the notes 🚀",

  // ExamDetail
  "Simulazione d'esame": "Exam simulation",
  "Cronometrata, domande da tutti gli argomenti, esercizi nuovi ogni volta":
    "Timed, questions from all topics, fresh exercises every time",
  "Ripasso veloce": "Quick review",
  "Domande rapide a crocette da tutti gli argomenti": "Quick multiple-choice questions from all topics",
  "📈 Storico simulazioni": "📈 Simulation history",
  "Confronta": "Compare",
  "Ultimo voto:": "Last grade:",
  "L'AI sta preparando il tuo esame...": "The AI is preparing your exam...",
  "Sto analizzando e dividendo gli appunti": "Analyzing and splitting your notes",
  "Errore nella generazione. Elimina l'esame e riprova con appunti più chiari.":
    "Generation error. Delete the exam and try again with clearer notes.",
  "Nessun argomento.": "No topics.",
  "Teoria": "Theory",
  "Formulario": "Formulas",
  "Memorizza": "Memorize",

  // Theory
  "Errore nel caricare la teoria. Riprova.": "Error loading the theory. Try again.",
  "L'AI sta preparando la spiegazione...": "The AI is preparing the explanation...",

  // Formulas
  "Errore nel caricare il formulario. Riprova.": "Error loading the formulas. Try again.",
  "L'AI sta raccogliendo tutte le formule...": "The AI is gathering all the formulas...",
  "tutte le formule da ricordare": "all the formulas to remember",
  "Nessuna formula disponibile.": "No formulas available.",
  "Simboli: ": "Symbols: ",
  "Quando si usa: ": "When to use: ",
  "Esame": "Exam",

  // Quiz
  "Scegli la modalita": "Choose the mode",
  "Domande curate o generate al volo dall'AI.": "Curated questions or generated on the fly by AI.",
  "📚 Domande classiche": "📚 Classic questions",
  "✨ Sfida AI (nuove domande)": "✨ AI Challenge (new questions)",
  "L'AI sta creando le tue domande...": "The AI is creating your questions...",
  "Caricamento quiz...": "Loading quiz...",
  "Livello superato!": "Level passed!",
  "Riprova!": "Try again!",
  "Boss sconfitto! 🪐": "Boss defeated! 🪐",
  "Ottimo lavoro 🚀": "Great job 🚀",
  "Non mollare, ci sei quasi.": "Don't give up, you're almost there.",
  "Rigioca livello": "Replay level",
  "Corretto! ": "Correct! ",
  "Spiegazione: ": "Explanation: ",

  // Flashcards
  "Formula": "Formula",
  "Definizione": "Definition",
  "Dimostrazione": "Proof",
  "Hai imparato tutte le carte! 🎉": "You've learned all the cards! 🎉",
  "Nessuna carta per questo argomento.": "No cards for this topic.",
  "Torna all'esame": "Back to exam",
  "Sessione completata!": "Session complete!",
  "carte che sai.": "cards you know.",
  "fronte": "front",
  "tocca per girare": "tap to flip",
  "Non la so": "I don't know it",
  "La so": "I know it",

  // Review
  "Ripasso completato!": "Review complete!",
  "corrette. Le domande sbagliate torneranno tra qualche giorno.": "correct. The ones you missed will come back in a few days.",
  "Inizia ripasso": "Start review",
  "Torna alla Home": "Back to Home",
  "Ripasso Intelligente": "Smart Review",
  "Riproponiamo le domande che hai sbagliato, a distanza crescente di giorni (1, 3, 7, 16) per fissarle nella memoria.":
    "We bring back the questions you got wrong, at increasing intervals (1, 3, 7, 16 days) to lock them into memory.",
  "da ripassare": "to review",
  "in attesa": "pending",
  "totali": "total",
  "Nessuna domanda da ripassare ancora. Gioca qualche livello!": "No questions to review yet. Play a few levels!",
  "Tutto ripassato per ora! Torna più tardi. 🎉": "All caught up for now! Come back later. 🎉",

  // QuickReview
  "Caricamento ripasso veloce...": "Loading quick review...",
  "Ripasso veloce completato · ": "Quick review complete · ",
  "Nuovo ripasso veloce": "New quick review",

  // Simulation
  "Preparo la simulazione d'esame... l'AI crea esercizi nuovi ogni volta.":
    "Preparing the exam simulation... the AI creates fresh exercises every time.",
  "Voto stimato": "Estimated grade",
  "Preparazione complessiva: ": "Overall preparation: ",
  "Ripasso mirato pronto": "Targeted review ready",
  "Punti forti": "Strengths",
  "Da migliorare": "To improve",
  "Nessuno ancora": "None yet",
  "Nessuno!": "None!",
  "Punteggio per argomento": "Score per topic",
  "Revisione": "Review",
  "Risposta corretta: ": "Correct answer: ",
  "Feedback: ": "Feedback: ",
  "Risposta modello:": "Model answer:",
  "Simulazione · ": "Simulation · ",
  "Rispondi a tutte le domande. Le domande aperte verranno valutate dall'AI. In bocca al lupo! 🎓":
    "Answer all the questions. Open questions will be graded by the AI. Good luck! 🎓",
  "Aperta": "Open",
  "Scelta multipla": "Multiple choice",
  "Scrivi qui la tua risposta / svolgimento... oppure allega una foto":
    "Write your answer / working here... or attach a photo",
  "Allega foto della soluzione": "Attach a photo of your solution",
  "Valutazione in corso...": "Grading...",
  "Consegna e valuta": "Submit and grade",
  "Tempo scaduto!": "Time's up!",

  // Progress
  "Cruscotto Progressi": "Progress Dashboard",
  "Avanzamento livelli": "Level progress",
  "livelli completati · ": "levels completed · ",
  "Esami": "Exams",
  "Streak": "Streak",
  "Trofei": "Trophies",
  "Simulazioni": "Simulations",
  "Livello": "Level",
  "Per esame": "By exam",
  "Nessun esame ancora.": "No exams yet.",
  "Miglior sim: ": "Best sim: ",

  // Compare
  "Servono almeno 2 simulazioni completate per il confronto. Fanne un'altra!":
    "You need at least 2 completed simulations to compare. Do another one!",
  "Confronto simulazioni": "Simulation comparison",
  "Prima": "Before",
  "Dopo": "After",
  "Per argomento": "By topic",

  // Study plans
  "I miei piani": "My plans",
  "Nuovo piano da appunti": "New plan from notes",
  "Nessun piano ancora. Creane uno dai tuoi appunti! 📚": "No plans yet. Create one from your notes! 📚",
  "Piano eliminato": "Plan deleted",
  "Piano da Appunti": "Plan from Notes",
  "Carica appunti o fonti: l'AI crea un piano, quiz e livelli su misura — includendo le basi necessarie per capire gli argomenti.":
    "Upload notes or sources: the AI creates a tailored plan, quizzes and levels — including the basics needed to understand the topics.",
  "Titolo (es. Aerodinamica - Cap. 3)": "Title (e.g. Aerodynamics - Ch. 3)",
  "Incolla qui i tuoi appunti o argomenti da studiare...": "Paste your notes or topics to study here...",
  "Carica PDF, testo o foto degli appunti": "Upload PDF, text or notes photos",
  "Giorni": "Days",
  "Ore/giorno": "Hours/day",
  "L'AI sta creando il piano...": "The AI is creating the plan...",
  "✨ Genera piano di studio": "✨ Generate study plan",
  "Aggiungi del testo o carica un file": "Add some text or upload a file",
  "Piano di studio creato! 🚀": "Study plan created! 🚀",
  "giorni": "days",
  "📅 Programma": "📅 Schedule",
  "Giorno": "Day",
  "📖 Teoria da studiare": "📖 Theory to study",
  "✏️ Esercizi da fare": "✏️ Exercises to do",
  "🎯 Livelli & Sfide": "🎯 Levels & Challenges",

  // Leaderboard
  "Classifica": "Leaderboard",
  "(tu)": "(you)",

  // Badges
  "sbloccati": "unlocked",
};

export function translate(lang, s) {
  if (lang !== "en") return s;
  return EN[s] ?? s;
}
